import * as fromActivity from './activity.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getActivityState = createFeatureSelector<fromActivity.ActivityState>('activity');
export const getActivityReport = createSelector(getActivityState, fromActivity.getActivityReport);
export const getFilter = createSelector(getActivityState, fromActivity.getFilter);
